(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    var productRecommendationsSection = document.querySelector(".product-recommendations");

    if (productRecommendationsSection === null) {
      return;
    }

    var recommended_url = productRecommendationsSection.dataset.baseUrl;
    var productId = productRecommendationsSection.dataset.productId;
    var limit = productRecommendationsSection.dataset.limit;

    var requestUrl = recommended_url + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;

    var request = new XMLHttpRequest();

    request.open("GET", requestUrl);

    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;

        var newRecommendations = container.querySelector(".product-recommendations");

        if (newRecommendations) {
          productRecommendationsSection.innerHTML = newRecommendations.innerHTML;
        }
      }
    };

    request.send();
  };

  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });

  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spec-sheets"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialise(root) {
    if (root.dataset.specReady === 'true') return;
    var search = root.querySelector('[data-spec-search]');
    var family = root.querySelector('[data-spec-family]');
    var model = root.querySelector('[data-spec-model]');
    var chapter = root.querySelector('[data-spec-chapter]');
    var reset = root.querySelector('[data-spec-reset]');
    var count = root.querySelector('[data-spec-results]');
    var empty = root.querySelector('[data-spec-empty]');
    var grid = root.querySelector('[data-spec-grid]');
    if (!search || !family || !model || !chapter || !reset || !grid) return;

    function key(value) {
      return (value || '').normalize('NFKC').toLowerCase().replace(/\s+/g, ' ').trim();
    }
    function searchKey(value) {
      return key(value).replace(/[^a-z0-9]+/g, ' ').trim();
    }
    var rows = Array.prototype.map.call(root.querySelectorAll('[data-spec-card]'), function (card) {
      return {
        card: card,
        family: key(card.getAttribute('data-family')),
        model: key(card.getAttribute('data-model')),
        chapter: key(card.getAttribute('data-chapter')),
        labels: {
          family: (card.querySelector('.saracen-card__family').textContent || '').trim(),
          model: (card.getAttribute('data-model') || '').trim(),
          chapter: (card.getAttribute('data-chapter') || '').trim()
        },
        search: searchKey(card.getAttribute('data-search')),
        name: card.querySelector('h2').textContent.trim()
      };
    });
    rows.sort(function (a, b) {
      return a.name.localeCompare(b.name, 'en', { numeric: true, sensitivity: 'base' });
    });
    rows.forEach(function (row) { grid.appendChild(row.card); });

    function options(select, field, candidates, placeholder) {
      var previous = select.value;
      var values = new Map();
      candidates.forEach(function (row) {
        if (row[field] && !values.has(row[field])) values.set(row[field], row.labels[field]);
      });
      select.replaceChildren(new Option(placeholder, ''));
      Array.from(values.keys()).sort(function (a, b) {
        return a.localeCompare(b, 'en', { numeric: true, sensitivity: 'base' });
      }).forEach(function (value) {
        select.add(new Option(values.get(value), value));
      });
      select.value = values.has(previous) ? previous : '';
      select.disabled = values.size === 0;
    }
    function modelRows() {
      return rows.filter(function (row) { return !family.value || row.family === family.value; });
    }
    function chapterOptions() {
      options(chapter, 'chapter', modelRows().filter(function (row) {
        return !model.value || row.model === model.value;
      }), 'All chapters');
    }
    function results() {
      var words = searchKey(search.value).split(' ').filter(Boolean);
      var visible = 0;
      rows.forEach(function (row) {
        var matches = (!family.value || row.family === family.value) &&
          (!model.value || row.model === model.value) &&
          (!chapter.value || row.chapter === chapter.value) &&
          words.every(function (word) { return row.search.indexOf(word) !== -1; });
        row.card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (count) count.textContent = visible + (visible === 1 ? ' result' : ' results');
      if (empty) empty.hidden = visible !== 0 || rows.length === 0;
    }
    options(family, 'family', rows, 'All Ranges');
    options(model, 'model', modelRows(), 'All models');
    chapterOptions();
    family.addEventListener('change', function () {
      model.value = '';
      chapter.value = '';
      options(model, 'model', modelRows(), 'All models');
      chapterOptions();
      results();
    });
    model.addEventListener('change', function () {
      chapter.value = '';
      chapterOptions();
      results();
    });
    chapter.addEventListener('change', results);
    search.addEventListener('input', results);
    search.addEventListener('search', results);
    reset.addEventListener('click', function () {
      search.value = '';
      family.value = '';
      model.value = '';
      chapter.value = '';
      options(model, 'model', rows, 'All models');
      chapterOptions();
      results();
      search.focus();
    });
    root.dataset.specReady = 'true';
    results();
  }
  function initialiseAll(scope) {
    if (scope.matches && scope.matches('[data-spec-sheets]')) initialise(scope);
    scope.querySelectorAll('[data-spec-sheets]').forEach(initialise);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); }, { once: true });
  } else {
    initialiseAll(document);
  }
  if (!window.saracenSpecsEditorListener) {
    document.addEventListener('shopify:section:load', function (event) { initialiseAll(event.target); });
    window.saracenSpecsEditorListener = true;
  }
})();

  } catch(e) { console.error(e); }
})();
})();
